import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeActorFields() {
        return {
            model: 'type_actor',
            label: 'Types Actor',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchSales(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/sales/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsSales(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/sales/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createSales(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/sales/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateSales(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/sales/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteSales(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/sales/${id}/`)
            .then((response) => {
                return response.data;
            })
    }
}